import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';
import SEO from '@/components/SEO';

const HOSTS = [
  { name: 'Dr. Neha Dewan', title: 'Founder, She Built This', bio: 'Co-Founder & CEO of SKI APAC FZCO. Researcher. Builder.' },
  { name: 'To Be Announced', title: 'Co-Host', bio: 'Details coming soon.' },
  { name: 'To Be Announced', title: 'Co-Host', bio: 'Details coming soon.' },
];

const PodcastPage = () => {
  return (
    <div data-testid="podcast-page" className="min-h-screen bg-[#FAF9F6]">
      <SEO title="She Built This Podcast" description="One table. Real women. No filter." url="https://shebuiltthis.com/podcast" />

      {/* Hero */}
      <section className="relative min-h-[70vh] flex items-center">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('https://images.pexels.com/photos/6860630/pexels-photo-6860630.jpeg?auto=compress&cs=tinysrgb&w=1920')` }} />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080808] via-[#080808]/85 to-[#080808]/60" />
        <div className="relative max-w-[1000px] mx-auto px-6 py-32 text-center">
          <p className="text-[10px] tracking-[0.35em] uppercase mb-6" style={{ fontFamily: "'DM Mono', monospace", color: '#C25E3E' }}>SHE BUILT THIS</p>
          <h1 className="text-5xl lg:text-[80px] leading-[0.95] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, color: '#F4F0E6' }}>THE PODCAST</h1>
          <p className="text-xl lg:text-2xl italic mb-12" style={{ fontFamily: "'Cormorant Garamond', serif", color: '#C25E3E' }}>One table. Real women. No filter.</p>
          <div className="flex flex-wrap justify-center gap-4">
            {['Spotify', 'Apple Podcasts', 'Amazon Music', 'YouTube'].map((p, i) => (
              <a key={p} href="#" className={`h-12 px-8 text-[12px] tracking-[0.1em] uppercase inline-flex items-center transition-all duration-300 ${i === 0 ? 'bg-[#C25E3E] text-[#080808] hover:bg-[#C25E3E]/80' : 'border border-[rgba(250,248,244,0.2)] text-[#1A1A1A] hover:border-[#C25E3E] hover:text-[#C25E3E]'}`} style={{ fontFamily: "'DM Mono', monospace" }} data-testid={`subscribe-${p.toLowerCase().replace(/ /g, '-')}`}>{p}</a>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Episode */}
      <section className="border-t border-[rgba(201,168,76,0.08)] py-20 px-6">
        <div className="max-w-[900px] mx-auto">
          <p className="text-[10px] tracking-[0.3em] uppercase mb-8" style={{ fontFamily: "'DM Mono', monospace", color: 'rgba(250,248,244,0.2)' }}>LATEST EPISODE</p>
          <div className="border-l-2 border-[#C25E3E] pl-8 lg:pl-12">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8">
              <div className="w-20 h-20 border-2 border-[#C25E3E] flex items-center justify-center flex-shrink-0 cursor-pointer hover:bg-[#C25E3E] hover:scale-110 transition-all group">
                <Play size={28} className="text-[#C25E3E] ml-1 group-hover:text-[#080808]" fill="currentColor" />
              </div>
              <div>
                <p className="text-[10px] tracking-[0.2em] uppercase mb-3" style={{ fontFamily: "'DM Mono', monospace", color: '#C25E3E' }}>EPISODE 01</p>
                <h2 className="text-3xl mb-3" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, color: '#F4F0E6' }}>Coming Soon: The First Episode</h2>
                <p className="text-base" style={{ fontFamily: "'Lora', serif", color: 'rgba(250,248,244,0.4)' }}>Three hosts, one guest, one question that drives everything. Launching with Edition 001.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Format */}
      <section className="bg-[#FAF9F6] py-24 lg:py-32 border-t border-[rgba(201,168,76,0.08)]">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <p className="text-[10px] tracking-[0.3em] uppercase mb-6" style={{ fontFamily: "'DM Mono', monospace", color: '#C25E3E' }}>THE FORMAT</p>
          <h2 className="text-4xl lg:text-[52px] leading-[1.05] mb-16" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, color: '#F4F0E6' }}>Not an interview. A conversation.</h2>
          <div className="grid grid-cols-3 gap-8">
            {[{ n: '3', t: 'Hosts', d: 'Three perspectives, not one. Real dialogue.' }, { n: '1', t: 'Guest', d: 'A woman who built something real. Not inspiration — evidence.' }, { n: '1', t: 'Question', d: 'One question drives each episode. Depth over breadth.' }].map((item) => (
              <div key={item.t} className="text-center">
                <p className="text-6xl lg:text-7xl font-light mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", color: '#C25E3E' }}>{item.n}</p>
                <h3 className="text-xl mb-2" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, color: '#F4F0E6' }}>{item.t}</h3>
                <p className="text-sm" style={{ fontFamily: "'Lora', serif", color: 'rgba(250,248,244,0.4)' }}>{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hosts */}
      <section className="py-24 lg:py-32 border-t border-[rgba(201,168,76,0.08)]">
        <div className="max-w-[1000px] mx-auto px-6 text-center">
          <p className="text-[10px] tracking-[0.3em] uppercase mb-6" style={{ fontFamily: "'DM Mono', monospace", color: 'rgba(250,248,244,0.2)' }}>MEET THE PANEL</p>
          <h2 className="text-4xl lg:text-[52px] leading-[1.05] mb-16" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, color: '#F4F0E6' }}>Your Hosts</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {HOSTS.map((host, i) => (
              <div key={i} className="text-center">
                <div className="w-28 h-28 mx-auto mb-6 bg-[#C25E3E] flex items-center justify-center">
                  <span className="text-4xl font-bold text-[#080808]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{host.name === 'To Be Announced' ? '?' : host.name.split(' ').map(n => n[0]).join('').slice(0, 2)}</span>
                </div>
                <h3 className="text-xl mb-1" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, color: '#F4F0E6' }}>{host.name}</h3>
                <p className="text-[10px] tracking-[0.15em] uppercase mb-3" style={{ fontFamily: "'DM Mono', monospace", color: '#C25E3E' }}>{host.title}</p>
                <p className="text-sm" style={{ fontFamily: "'Lora', serif", color: 'rgba(250,248,244,0.4)' }}>{host.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Be a Guest */}
      <section className="relative py-20 lg:py-24 border-t border-[rgba(201,168,76,0.08)]">
        <div className="absolute inset-0 bg-[#FAF9F6]" />
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(201,168,76,0.5) 0%, transparent 50%)' }} />
        <div className="relative max-w-[800px] mx-auto px-6 text-center">
          <div className="w-16 h-[1px] mx-auto mb-10" style={{ background: 'linear-gradient(to right, transparent, #C25E3E, transparent)' }} />
          <h2 className="text-4xl lg:text-[52px] leading-[1.05] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, color: '#F4F0E6' }}>Be a Guest</h2>
          <p className="text-lg mb-10" style={{ fontFamily: "'Lora', serif", color: 'rgba(250,248,244,0.4)' }}>Built something real? Guest applications are reviewed by Dr. Neha Dewan.</p>
          <a href="mailto:support@shebuiltthis.com?subject=Podcast Guest Application" className="inline-flex items-center h-14 px-10 border border-[#C25E3E] text-[#C25E3E] text-[13px] tracking-[0.12em] uppercase transition-all hover:bg-[#C25E3E] hover:text-[#080808]" style={{ fontFamily: "'DM Mono', monospace" }} data-testid="apply-guest">Apply to Be a Guest</a>
        </div>
      </section>

      {/* Episodes Archive */}
      <section className="py-24 lg:py-32 border-t border-[rgba(201,168,76,0.08)]">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <p className="text-[10px] tracking-[0.3em] uppercase mb-6" style={{ fontFamily: "'DM Mono', monospace", color: 'rgba(250,248,244,0.2)' }}>ALL EPISODES</p>
          <h2 className="text-4xl lg:text-[52px] leading-[1.05] mb-8" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, color: '#F4F0E6' }}>The Archive</h2>
          <p className="text-base mb-10" style={{ fontFamily: "'Lora', serif", color: 'rgba(250,248,244,0.4)' }}>Episodes launching with She Built This Edition 001 in 2026.</p>
          <Link to="/participate" className="inline-flex items-center h-14 px-10 bg-[#C25E3E] text-[#080808] text-[13px] tracking-[0.12em] uppercase transition-all hover:bg-[#C25E3E]/80" style={{ fontFamily: "'DM Mono', monospace" }}>Join Edition 001</Link>
        </div>
      </section>
    </div>
  );
};

export default PodcastPage;
